import { Row, Text } from "@/components";
import { LeaderPetName } from "@/components/leaderboard/LeaderPetName";

import type { LeaderboardUser } from "@/types";

const TOP_PERFORMER_PET_SIZE_PX = 42;
const TOP_PERFORMER_DUNE_WORM_SIZE_PX = 68;

export const TopPerformerLeaders = ({
  leaders,
  isDark = false,
}: {
  leaders: LeaderboardUser[];
  isDark?: boolean;
}) => {
  /* Render */
  const render = () => {
    if (leaders.length === 0) {
      return (
        <Text
          className={
            isDark
              ? "text-sm font-medium text-slate-500"
              : "text-sm font-medium text-slate-400"
          }
        >
          —
        </Text>
      );
    }

    if (leaders.length === 1) {
      return (
        <LeaderPetName
          leader={leaders[0]}
          petSizePx={TOP_PERFORMER_PET_SIZE_PX}
          duneWormPetSizePx={TOP_PERFORMER_DUNE_WORM_SIZE_PX}
          textClassName={
            isDark
              ? "text-base font-semibold text-slate-100"
              : "text-base font-semibold text-slate-900"
          }
        />
      );
    }

    return (
      <Row className="min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
        {leaders.map((leader) => (
          <LeaderPetName
            key={leader.userId}
            leader={leader}
            petSizePx={TOP_PERFORMER_PET_SIZE_PX}
            duneWormPetSizePx={TOP_PERFORMER_DUNE_WORM_SIZE_PX}
            textClassName={
              isDark
                ? "text-xs font-medium text-slate-100"
                : "text-xs font-medium text-slate-900"
            }
          />
        ))}
      </Row>
    );
  };

  return render();
};
